export enum EASMScanConfigurationEvents {
  ADD_ASSET_TO_SCAN = 'add-asset-to-scan',
  REMOVE_ASSET_FROM_SCAN = 'remove-asset-from-scan',
}

export enum ResponseFailReason {
  REASON_TYPE_INVALID_INPUT,
  REASON_TYPE_FAILED_OPERATION,
  REASON_TYPE_NO_ASSETS_FOUND,
  REASON_TYPE_OPERATION_NOT_ALLOWED,
  REASON_TYPE_MAXIMUM_SCANS_REACHED,
  REASON_TYPE_SUSPENDED_COMPANY,
  REASON_TYPE_DUPLICATED_SCAN,
  REASON_TYPE_DUPLICATED_ASSET,
  REASON_TYPE_INCLUDED_ASSET_TYPE_NOT_SUPPORTED,
  REASON_TYPE_INTERNAL_ERROR,
  REASON_TYPE_NO_LICENSE,
  REASON_TYPE_NO_ASSETS_UPDATED,
}

export interface EASMScanConfigurationResponse {
  success: boolean;
  reason?: ResponseFailReason;
}
